export default "__VITE_ASSET__BGgGK7zd__"